export const UnsupportedPropertyError = (propertyPath: string) =>
  new Error(`Unsupported property "${propertyPath}"`)

export const InvalidValueError = (
  propertyPath: string,
  expectedType?: string,
  actualValue?: any,
) => new Error(`${propertyPath} must be ${expectedType}, got "${actualValue}"`)
